module.exports = __webpack_public_path__ + "2f832e05f5d40db45143c97f22fcf501.ttf";